import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import ServiceTypeForm from "./ServiceTypeForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { serviceTypetValidationForm } from "../../utils/validationSchemas";
//@ts-ignore

const EditServiceType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(serviceTypetValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
      };
    },
  });
  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <ServiceTypeForm errors={errors} register={register} />
    </FormLayout>
  );
};

export default EditServiceType;
